import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { ApiConstant, LangConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";
import qs from "qs";
import { BOT_ACCOUNT_PHONE } from "../../const/system.const";

const useAccountBot = props => {
  const { t: getLabel } = useTranslation();

  const { data, isLoading, isError, isFetching, refetch } = useQuery({
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    queryKey: [ApiConstant.REACT_QUERY_KEYS.getBotAccount],

    queryFn: async () => {
      const apiPayload = {
        paging: 0,
        asc:1,
        offset: 0,
        limit: 1,
        filter: `{"phone":"${BOT_ACCOUNT_PHONE}"}`
      };
      let response = await ApiUtils.createApiWithToken(false).get(
        ApiConstant.SEARCH_USER,
        HumpUtils.decamelizeKeys(apiPayload),
      );
      console.log(response.data.data.data)
      if (response.data.data.data.length > 0) return response.data.data.data[0]
      else return {}
    },

    onSuccess: response => {},

    onError: error => {
      console.log(error);
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_UPDATE_ERROR), "error");
    },
  });

  const account = data || {};

  return {
    account: account || {},
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};

export default useAccountBot;
